import { useTranslation } from "react-i18next";
import CommonModal from "PhishingManager/components/Modal";
import { ModalProps } from "PhishingManager/components/Modal/Modal.types";

const ThreeMonthWhitelistingModal = ({
    open,
    onClose,
    onConfirm
}: ModalProps) => {
    const { t } = useTranslation();

    return (
        <CommonModal
            visible={open}
            confirmText={t("phishingManager.threeMonthWhitelistingModal.confirmText")}
            cancelText={t("phishingManager.threeMonthWhitelistingModal.cancelText")}
            iconType={null}
            modalTitle={t("phishingManager.threeMonthWhitelistingModal.title")}
            modalContentDesc={[
                t("phishingManager.threeMonthWhitelistingModal.description.line1"),
                t("phishingManager.threeMonthWhitelistingModal.description.line2")
            ]}
            onClose={onClose}
            onConfirm={onConfirm}
        />
    );
};

export default ThreeMonthWhitelistingModal;